import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-fedex-manage',
  templateUrl: './fedex-manage.component.html',
  styleUrls: ['./fedex-manage.component.scss'],
})
export class FedexManageComponent implements OnInit {

  carrierNameError: string;
  clientIdError: string;
  clientSecretError: string;
  fedExData: any;

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.api.getCarrierInfoById(this.user.accountOwnerId, this.route.snapshot.paramMap.get('id'), this.user.organizationId).subscribe((data: any) => {
      this.fedExData = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }
  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.fedExData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  clientIdBlur() {
    this.clientIdError = "";
    if (!this.fedExData.clientId) {
      this.clientIdError = 'Please enter clientId';
    }
  }

  clientSecretBlur() {
    this.clientSecretError = "";
    if (!this.fedExData.clientSecret) {
      this.clientSecretError = 'Please enter client secret';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.clientIdError = "";
    this.clientSecretError = "";

    if (!this.fedExData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.fedExData.clientId) {
      this.clientIdError = 'Please enter clientId';
    }
    if (!this.fedExData.clientSecret) {
      this.clientSecretError = 'Please enter client secret';
    }
    if (this.carrierNameError != "" || this.clientSecretError != "" || this.clientIdError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {

      "clientId": this.fedExData.clientId,
      "accountOwnerId": this.user.accountOwnerId,
      "carrierCode": this.fedExData.carrierCode,
      "connectionName": this.fedExData.connectionName,
      "organizationId": this.user.organizationId,
      "clientSecret": this.fedExData.clientSecret,
      "carrierId": this.fedExData.carrierId,
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Fed Ex', 'Update Successfully');
          this.router.navigate(['/admin/customerCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}
